import { render, staticRenderFns } from "./McInfo.vue?vue&type=template&id=339031d2&scoped=true"
import script from "./McInfo.vue?vue&type=script&lang=js"
export * from "./McInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339031d2",
  null
  
)

export default component.exports